import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const MonthHeaderCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px 24px;
  border-radius: 24px;
  background: ${ColorV2.White};
  width: 1416px;
  max-width: 100%;
  margin-top: 16px;
`;

export const MonthView = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
`;

export const MonthHeader = styled.div`
  display: flex;
  justify-content: center;
`;

export const MonthRowSticky = styled.div<{ $visible: boolean }>`
  position: sticky;
  top: 16px;
  z-index: 3;
  display: flex;
  justify-content: center;
  height: 56px;
  margin-top: -56px;
  opacity: ${(props) => (props.$visible ? 1 : 0)};
  visibility: ${(props) => (props.$visible ? "visible" : "hidden")};
  pointer-events: ${(props) => (props.$visible ? "auto" : "none")};
  transform: translateY(${(props) => (props.$visible ? "0" : "-6px")});
  transition: opacity 220ms ease, transform 220ms ease;
`;

export const MonthRowStickyCard = styled.div`
  background: ${ColorV2.White};
  border-radius: 24px;
  padding: 12px 24px;
  width: 1416px;
  max-width: 100%;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
`;

export const MonthRow = styled.div<{ $leftColumnWidth: number; $gap: number }>`
  display: grid;
  grid-template-columns: ${(props) => props.$leftColumnWidth}px repeat(
      var(--day-count),
      minmax(0, 1fr)
    );
  gap: ${(props) => props.$gap}px;
  width: 100%;
`;

export const MonthRowSpacer = styled.div`
  height: 26px;
`;

export const DaySlot = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  height: 26px;
  background: ${(props) => (props.$isSelected ? ColorV2.Blue6 : "transparent")};
`;

export const DayNumber = styled.span<{
  $isWeekend: boolean;
  $isSelected: boolean;
}>`
  ${TypographyV2.s1};
  color: ${(props) =>
    props.$isSelected
      ? ColorV2.Blue1
      : props.$isWeekend
        ? ColorV2.NegativeRed
        : ColorV2.Blue4};
`;
